export default __webpack_public_path__ + "static/media/flash_pay_banner.a14fe13a.png";